const init = (el) => {
    el.innerHTML = 'I am a simple object based component. Cheers!';
};

export default {
    init
};
